import { render, staticRenderFns } from "./dashboard-admin.html?vue&type=template&id=2c856960&scoped=true&external"
import script from "./dashboard-admin.js?vue&type=script&lang=js&external"
export * from "./dashboard-admin.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-admin.scss?vue&type=style&index=0&id=2c856960&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c856960",
  null
  
)

export default component.exports